 <div class="dialog-container">
    <header class="dialog-header p-lr20 p-t20" >
        <div  class="flex-row-container">    
            <span class="flex-1 B font18">Create Plan</span>
            <mat-icon class="pointer" aria-hidden="false" (click)="cancelCreatePlan()">close</mat-icon>
        </div>    
    </header>
    <main class="dialog-content m-10">
          <gp-client-profile [Plan]="inFlightPlan" (ValidateProfile)="onValidateProfile($event);"></gp-client-profile>                  
    </main>
    <footer class="flex-col-end m-10">
        <mat-divider class="divider" style="width: 99%"></mat-divider>
        <div class="flex-row-container m-t15">
            <button mat-button color="primary" (click)="cancelCreatePlan()">Cancel</button>
            <button class="m-lr10" mat-raised-button color="primary" [disabled]="!isProfileValid || isCreatePlanClicked" (click)="createPlan()">Create Plan</button>
        </div>
    </footer>
  </div>